export default __webpack_public_path__ + "images/SpeakersPhotos/Foto tirso maldonado.jpg?9e8bf292";